import { Injectable, signal } from "@angular/core";

import { Subject } from "rxjs";

import {
  ActiveRound,
  BetEvent,
  CellState,
  CurrencySettings,
  FreeBet,
  GameSettings,
  InitSettings,
  MenuState,
  MinesOption,
  Operation,
  Round,
  SessionResp,
  Tournament,
} from "@models";

@Injectable({ providedIn: "root" })
export class ActionService {
  /*Rounds*/
  public readonly rd$ = signal<Round[]>([]);
  /*Waiting Round*/
  public readonly wR$ = signal<string>("");
  /*Loading Round*/
  public readonly lR$ = signal<boolean>(false);
  /*Animation Progress*/
  public readonly aP$ = signal<boolean>(false);
  /*Wait Pick*/
  public readonly wP$ = signal<boolean>(false);
  /*Mines Count*/
  public readonly mc$ = signal<MinesOption | null>(null);
  /*Balance*/
  public readonly ba$ = signal<string>("0");
  /*Free Bets*/
  public readonly fB$ = signal<FreeBet[]>([]);
  /*Tournament*/
  public readonly t$ = signal<Tournament | null>(null);
  /*Menu State*/
  public readonly mS$ = signal<MenuState | null>(null);
  /*Client Seed*/
  public readonly cS$ = signal<string>("");
  /*Session Response*/
  public readonly sR$ = signal<SessionResp | null>(null);
  /*Init Response*/
  public readonly iS$ = signal<InitSettings | null>(null);
  /*Currency Settings BE*/
  public readonly cSB$ = signal<CurrencySettings | null>(null);
  /*Game Settings BE*/
  public readonly gSB$ = signal<GameSettings | null>(null);
  /*Active round*/
  public readonly aR$ = signal<ActiveRound | null>(null);
  /*Cells State*/
  public readonly cells$ = signal<CellState[]>([]);

  /*Bet*/
  public readonly bE$ = new Subject<BetEvent>();
  /*Bet Operation*/
  public readonly oE$ = new Subject<Operation>();
  /*Tile Event*/
  public readonly tE$ = new Subject<CellState>();
}
